/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Heading, HFlow, Icon, VFlow } from 'bold-ui'

import { MChatRfModalButtonClose } from '../../components/MChatRfModalButtonClose'

interface ConsultaSeguimentoModalTabResultadoProps {
  onGoBackToAplicacao: () => void
  onClose: () => void
}

export function ConsultaSeguimentoModalTabResultado(props: Readonly<ConsultaSeguimentoModalTabResultadoProps>) {
  const { onGoBackToAplicacao, onClose } = props

  return (
    <VFlow>
      <VFlow vSpacing={2}>
        <HFlow alignItems='flex-start' justifyContent='space-between'>
          <Button kind='normal' size='small' onClick={onGoBackToAplicacao}>
            <Icon icon='arrowLeft' style={styles.backIcon} />
            Voltar à avaliação
          </Button>
          <MChatRfModalButtonClose onClose={onClose} />
        </HFlow>
        <Heading level={1}>Resultado Entrevista de seguimento</Heading>
      </VFlow>
    </VFlow>
  )
}

const styles = {
  backIcon: css`
    margin-right: 0.5rem;
  `,
}
